
        import * as module0 from './controllers/countdown_controller.js';import * as module1 from './controllers/secrets_controller.js'
        const modules = {
            "./controllers/countdown_controller.js": module0,
            "./controllers/secrets_controller.js": module1,
        };
        export default modules;
      